/*
 * This file is part of the Convergence API Server.
 *
 * (c) Convergence <https://convergence.finance/>
 */

import React, { MouseEventHandler } from "react";
import {
    DESIGN_ACTIVITIES_FILTER,
    GRANT_STATUS_FILTER,
    IMPACT_THEMES_FILTER,
    PAGE_GRANT,
    REGIONS_FILTER,
    SECTORS_FILTER,
    DESIGN_FUNDING_WINDOW_FILTER
} from "../../../constants";
import {
    getWindowBadgeColour,
    toContentfulFilters
} from "../../../utils/CommonUtils";
import BaseContentfulPagedListing from "../../general/BaseContentfulPagedListing";
import PagedContentfulFilterBar from "../../general/PagedContentfulFilterBar";
import ArticleBox from "../../layout/ArticleBox/ArticleBox";
import Loader from "../../layout/Loader";
import DesignFundingWindowFilter from "../../general/DesignFundingWindowFilter";

type Props = {
    designFundingWindowId?;
};

class GrantPortfolio extends BaseContentfulPagedListing<Props> {
    contentType: string;
    initialFilters: any;
    defaultFilter: string;

    constructor(props) {
        super(props);

        this.contentType = PAGE_GRANT;

        const queryData = this.getQueryData();
        this.initialFilters = {
            ...(typeof queryData.filters === "object" ? queryData.filters : {})
        };

        this.availableFilters = {
            designFundingWindow: DESIGN_FUNDING_WINDOW_FILTER,
            designActivity: DESIGN_ACTIVITIES_FILTER,
            sectors: SECTORS_FILTER,
            regions: REGIONS_FILTER,
            impactThemes: IMPACT_THEMES_FILTER
            // progressStatus: GRANT_STATUS_FILTER
        };

        // this.defaultFilter = "designFundingWindow";

        if (typeof this.props.designFundingWindowId !== "undefined") {
            this.permanentFilters = {
                "fields.designFundingWindow.sys.id": this.props
                    .designFundingWindowId
            };
            this.defaultFilter = "designActivity";
            delete this.availableFilters["designFundingWindow"];
        } else {
            this.contentfulService
                .getFundingWindows()
                .then((articles) => {
                    if (!articles) return;
                    const windows = [];
                    for (const article of articles) {
                        if (article.pageSlug !== "education-financing-prize") {
                            windows.push(article.windowName);
                        }
                    }
                    this.availableFilters["designFundingWindow"].options = () =>
                        windows;
                    this.setState({ loading: false });
                })
                .catch((error) => {
                    console.error(error);
                    this.setState({ loading: false });
                });
        }

        this.state = {
            loadingMore: false,
            disableLoadMore: false,
            loading: true,
            skip: 0,
            limit: 12,
            contentful: {
                orderDirection: "DESC",
                orderByField: "fields.date",
                query: queryData.keyword ? queryData.keyword : "",
                filters: {}
            },
            articles: []
        };
    }

    render() {
        const {
            loading,
            loadingMore,
            disableLoadMore,
            articles,
            contentful
        } = this.state;

        return (
            <div className={" pb-4"}>
                <div className={"row mb-4"}>
                    <div className={"col-12"}>
                        {!loading && (
                            <PagedContentfulFilterBar
                                initialFilters={this.initialFilters}
                                availableFilters={this.availableFilters}
                                defaultFilter={this.defaultFilter}
                                updateState={this.updateState}
                                toContentfulFilters={toContentfulFilters}
                                contentful={contentful}
                            />
                        )}
                    </div>
                </div>
                <div className={"row"}>
                    {loading && (
                        <div className={"col-12"}>
                            <Loader />
                        </div>
                    )}
                    {!loading && (
                        <>
                            {articles &&
                                articles.length > 0 &&
                                articles.map((article) => {
                                    const link = {
                                        routeKey:
                                            "design-funding-grant-portfolio-view-grant",
                                        href: "/design-funding/:id/view",
                                        as: `/design-funding/${article.id}/view`,
                                        query: { id: article.id }
                                    };

                                    return (
                                        <ArticleBox
                                            className={"cardboard"}
                                            key={article.id}
                                            wrapperContent={
                                                <div
                                                    className={getWindowBadgeColour(
                                                        article
                                                            .designFundingWindow
                                                            .fields.windowName
                                                    )}
                                                    style={{
                                                        position: "relative"
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            justifyContent:
                                                                "end",
                                                            fontSize: ".65rem",
                                                            fontWeight: "bold"
                                                        }}
                                                    >
                                                        {article.designFundingWindow &&
                                                            article
                                                                .designFundingWindow
                                                                .fields &&
                                                            article
                                                                .designFundingWindow
                                                                .fields
                                                                .windowName && (
                                                                <div
                                                                    className={`   border-white`}
                                                                    style={{
                                                                        paddingTop:
                                                                            ".3rem",
                                                                        paddingBottom:
                                                                            ".3rem",
                                                                        paddingLeft:
                                                                            ".36rem",
                                                                        paddingRight:
                                                                            ".36rem",
                                                                        textAlign:
                                                                            "end"
                                                                    }}
                                                                >
                                                                    {article.designFundingWindow.fields.windowName.replace(
                                                                        "Design Funding Window",
                                                                        "Window"
                                                                    )}
                                                                </div>
                                                            )}
                                                    </div>
                                                </div>
                                            }
                                            topContent={
                                                <div
                                                    style={{
                                                        position: "relative"
                                                    }}
                                                >
                                                    {article.organization}
                                                </div>
                                            }
                                            middleContent={article.title}
                                            bottomContent={
                                                article.yearAndQuarter
                                            }
                                            link={link}
                                            linkTitle={article.title}
                                            // image={article.image}
                                            hideDefaultImage
                                            imageTitle={article.title}
                                            imagePosition={"logo"}
                                            columnSizes={{
                                                xl: 4,
                                                lg: 4,
                                                md: 6,
                                                sm: 6,
                                                xs: 12
                                            }}
                                        />
                                    );
                                })}
                            {articles && articles.length <= 0 && (
                                <div className={"col-12"}>
                                    <div className={"alert alert-info"}>
                                        Sorry, no articles were found. Try
                                        changing your search or filter criteria.
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </div>
                {!disableLoadMore && (
                    <div className={"row"}>
                        <div className={"col-12 text-center"}>
                            <button
                                className={"btn btn-primary"}
                                onClick={this.loadMore}
                                disabled={loading || loadingMore}
                            >
                                {loadingMore ? "Loading..." : "Load More"}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default GrantPortfolio;
